import {
    CTRL_GET_COMMUNITY_DETAILS,
    CTRL_BRAND_LIST,
    CTRL_CREATE_BRAND,
    CTRL_EDIT_BRAND,
    CTRL_GET_BRAND,
    CTRL_DELETE_BRAND,
} from '../../index.types';


/* =========================
   GET COMMUNITY LIST
========================= */
export function getBrandsList(data) {
    return {
        type: CTRL_BRAND_LIST,
        data
    };
}

/* =========================
   CREATE COMMUNITY
========================= */
export function createBrand(data) {
    return {
        type: CTRL_CREATE_BRAND,
        data
    };
}

/* =========================
   EDIT COMMUNITY
========================= */
export function editBrand(data) {
    return {
        type: CTRL_EDIT_BRAND,
        data
    };
}


/* =========================
   GET COMMUNITY
========================= */
export function getBrand(data) {
    return {
        type: CTRL_GET_BRAND,
        data
    };
}


/* =========================
   GET COMMUNITY DETAILS
========================= */
export function getCommunityDetails(data) {
    return {
        type: CTRL_GET_COMMUNITY_DETAILS,
        data
    };
}

/* =========================
   DELETE COMMUNITY
========================= */
export function deleteBrand(data) {
    return {
        type: CTRL_DELETE_BRAND,
        data
    };
}

